/* Seller Shipping · /seller/shipping
 *
 * Feature-parity wrapper around the buyer's shipping workbench —
 * delegates to `BuyerShipping` with `persona="seller"` so both surfaces
 * share the same 5-tab UI (Book / My shipments / Track / Docs / Rates).
 * `BuyerShipping` handles the persona-specific gating:
 *   • Scopes orders to `shipping_mode === "seller"`.
 *   • Renders the "Shipments isn't enabled" empty state when the tenant
 *     hasn't turned on `offer_seller_arranged_shipping`.
 *   • Hides Hub-mode / supplier-context UI (buyer-only concepts).
 *   • Uses `${persona}-shipping-*` data-testids.
 * See: /app/frontend/src/pages/buyer/BuyerShipping.jsx
 */
import BuyerShipping from "../buyer/BuyerShipping";

export default function SellerShipping() {
  return <BuyerShipping persona="seller" />;
}
